import CTASection from './CTASection';
import NewsItem from './NewsItem';
import PropTypes from 'prop-types';
import React from 'react';
import useIsMobile from './hooks/isMobile';

const NewsBlock = ({data, cmsData, mobile, appImage, ctaString, isSubscribed, isLoggedIn, isGameLaunched, ...props}) => {
    const isMobile = useIsMobile(mobile);
    const blogStore = data || {};
    const {blogList = []} = blogStore;
    const {title = '', postPerPage = 4} = cmsData;
    const slicedBlogList = blogList.slice(0, postPerPage);
    const showBlogs = slicedBlogList.length > 0;
    const {launched, info} = isGameLaunched;

    return (
        <section className="news-block">
            <div className="container-fluid section">
                <div className="row">
                    <div className="col-xs-12">
                        <h2>{title}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="blog-container">
                            {showBlogs && slicedBlogList.map((item) => {
                                return (<NewsItem isMobile={isMobile} key={`blog-${item.slug}`} data={item} />)
                            })}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <CTASection
                            launched={launched}
                            info={info}
                            appImage={appImage}
                            cta={ctaString}
                            isSubscribed={isSubscribed}
                            isLoggedIn={isLoggedIn}
                            {...props} />
                    </div>
                </div>
            </div>
        </section>
    );
};
NewsBlock.propTypes = {
    data: PropTypes.object,
    mobilePostNum: PropTypes.number,
    enableAutoShortDescription: PropTypes.bool,
    cmsData: PropTypes.object,
    mobile: PropTypes.bool,
    isGameLaunched: PropTypes.object,
    appImage: PropTypes.string,
    isSubscribed: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    ctaString: PropTypes.string

}

export default NewsBlock;
